module.exports = __webpack_public_path__ + "img/diamond-background.a20b6e34.png";